import React from 'react';

const FormError = (props)=>{
    return(
        <div className={props.errors.length>0?"form-error":"d-none"}>	
            <div className="alert alert-warning mb-0 mt-3">
                <div>Please complete the form.</div>
            </div>								
            <div className="d-none">
                Error:
                <ul>
                    {	
                        props.errors.map((err, i)=>{
                            return(
                                <li key={i}>{`${err.message}`}</li>
                            )
                        })
                    }
                </ul>
            </div>									
        </div>
    )
}

export default FormError;


// WEBPACK FOOTER //
// ./src/view/FormError.js